import Vue from 'vue';
import App from './App.vue';
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue';

import 'jquery-ui-bundle';
import 'jquery-ui-bundle/jquery-ui.min.css';

Vue.use(Vuex);

Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import '../node_modules/ag-grid-community/dist/styles/ag-grid.css';
import '../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

import 'ag-grid-enterprise';

import 'ag-grid-enterprise/main';

import { LicenseManager } from 'ag-grid-enterprise/main';

LicenseManager.setLicenseKey('UAB_Visata_ERP_Falcon_1Devs27_September_2019__MTU2OTUzODgwMDAwMA==3aff6e043812fd351c9dc0084b0269ff');

import pdfMake from 'pdfmake/build/pdfmake.js';
import pdfFonts from 'pdfmake/build/vfs_fonts.js';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
Vue.use(pdfMake);

import '../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
import './assets/styles/main.scss'

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

const nProgressOptions = {
  latencyThreshold: 200,
  minimum: 0.1
};
Vue.use(NProgress, nProgressOptions);

import VueSweetAlert2 from 'vue-sweetalert2';

import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetAlert2);

import { store } from './store';
import { router } from './routes/routes.js';
import { checkRoutePermissions, setUserPermission } from './routes/routeController'

import VueResource from 'vue-resource';

import ru from './i18n/ru.json'
import en from './i18n/en.json'
import lt from './i18n/lt.json'

const messages = {en, ru, lt};

import VueI18n from 'vue-i18n'

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'en',
  messages
});

import '../node_modules/vue-awesome/icons'

import Icon from '../node_modules/vue-awesome/components/Icon';

Vue.component('icon', Icon);

Vue.use(VueResource);

import { API_URL } from './config/config';

Vue.http.options.root = API_URL;

import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton);

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(VueLoading);

import PortalVue from 'portal-vue'

Vue.use(PortalVue)

Vue.http.headers.common['Accept-Language'] = localStorage.getItem('lang') || 'en';

let requests = [];
let responses = [];
Vue.http.interceptor.before = request => {
  requests.push(request);
}
Vue.http.interceptors.push((request, next) => {
  NProgress.start();
  next((response) => {
    if (response.status === 401) {
      router.push('/login');
    }
    responses.push(response);
    setTimeout(() => {
      if (responses.length === requests.length) {
        NProgress.done();
      }
    });
  });
});

import HistoryModalGridButton from './components/common/HistoryModalGridButton';

Vue.component('HistoryModalGridButton', HistoryModalGridButton)

import EditGridButton from './components/common/EditGridButton';

Vue.component('EditGridButton', EditGridButton)


import Notifications from 'vue-notification'

Vue.use(Notifications);

import { setToken } from './helpers/commonHelpers';

import { FACTORY_NAME } from './config/config';

document.title = `${FACTORY_NAME}`;

const checkComponentsVersions = async () => {
  const componentsKey = 'components-versions';
  try {
    const componentsVersionInLocalStorage = localStorage.getItem(componentsKey);
    const componentsVersions = await store.dispatch('generic/getComponentsVersions');
    if (componentsVersionInLocalStorage) {
      const versionsInLocalStorage = JSON.parse(componentsVersionInLocalStorage);
      const menuVersionInLocalStorage = versionsInLocalStorage[SIDE_MENU_KEY];
      const menuVersion = componentsVersions[SIDE_MENU_KEY];
      if (menuVersionInLocalStorage !== menuVersion) {
        localStorage.removeItem(SIDE_MENU_KEY);
        versionsInLocalStorage[SIDE_MENU_KEY] = menuVersion;
        localStorage.setItem(componentsKey, JSON.stringify(versionsInLocalStorage));
      }
    } else {
      localStorage.setItem(componentsKey, JSON.stringify(componentsVersions));
    }
  } catch (e) {
    localStorage.removeItem(SIDE_MENU_KEY);
    localStorage.removeItem(componentsKey);
    throw e;
  } finally {
    store.commit('menu/setVisibleMenuItems', store.state.generic.permissionsList);
  }
}

router.beforeEach(async (to, from, next) => {
    if (!store.username && localStorage.getItem('login')) {
      setToken(localStorage.getItem('token'));
    }

    const changeRoute = () => {
      setUserPermission(to.meta.routeName);
      document.title = `${FACTORY_NAME}: ${to.meta.title}`;
      next();
    };

    if (to.path === '/login') {
      changeRoute();
    } else if (from.path === '/' && localStorage.getItem('login')) {
      //check if user trying to enter the system from foreign page (not praslas website page) and already have a saved token
      await store.dispatch('generic/loadUserPermissions');
      await checkComponentsVersions();
      if (checkRoutePermissions(to.meta.routeName)) {
        //if user have permissions - change route
        changeRoute();
      } else {
        //if use don't have permissions - show index page
        router.push('/');
      }
    } else {
      //if user going from one praslas page to another - check permissions and, if he is able to view the page, change the route
      if (checkRoutePermissions(to.meta.routeName)) {
        changeRoute();
      }
    }
  }
);

router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});

import {
  onlyPositiveInteger,
  digitsAfterDecimal,
  replaceWithNegative,
  replaceWithPositive
} from './directives/NumericInputDirectives.js';


import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

Vue.use(PerfectScrollbar);

import { SIDE_MENU_KEY } from '@/constants';

new Vue({
  el: '#app',
  store,
  router,
  i18n,
  render: h => h(App),
  async created() {
    await this.checkLogin();
    this.loadNotificationsCount();
    this.$store.cache.dispatch('woodware/getBaseCurrency');
  },
  methods: {
    async checkLogin() {
      if (!localStorage.getItem('token') && !localStorage.getItem('login')) {
        this.$router.push('/login');
        return;
      }
      if (!this.$store.username && localStorage.getItem('login')) {
        setToken(localStorage.getItem('token'));
        await this.$store.dispatch('login/updateUserName', {username: localStorage.getItem('username')});
        return;
      }
    },
    loadNotificationsCount() {
      if (localStorage.getItem('token') && localStorage.getItem('login')) {
        this.$store.dispatch('generic/loadNotificationsCount');
      }
    }
  },
  watch: {
    '$route'(to) {
      if (to.path !== '/login') {
        setToken(localStorage.getItem('token'));
        this.loadNotificationsCount();
      }
      this.$store.dispatch('location/deletePaths');
      this.$store.dispatch('location/setBreadcrumbsList', this.$route.meta.breadcrumb);
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js